import { purgeStoredState } from "redux-persist";

const token = "KYN_TOKEN";

export const setToken = accessToken => {
  window.localStorage.setItem(token, accessToken);

  return accessToken;
};

export const getToken = () => {
  return window.localStorage.getItem(token);
};

export const deleteToken = () => {
  return window.localStorage.removeItem(token);
};

export const clearAll = () => {
  return window.localStorage.clear();
}

export const backToLoginPage = () => {
  deleteToken();
  purgeStoredState();
  window.location.href = "/";
};



// WEBPACK FOOTER //
// ./src/utils/token.js